import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import { ComparisonPage } from "../harvest-comparison";

const HarvestComparisonPage = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <ComparisonPage />
            </Box>
        </Box>
    );
};

export default HarvestComparisonPage;
